/**
 * Affirm payment method - uses shared BNPL factory.
 */

import { SHORT_POPUP_CLOSED_GRACE_MS } from "./bnpl-lifecycle";
import {
  type BnplCheckoutResponse,
  type BnplCustomerInfo,
  type BnplSubmitOptions,
  createBnplPaymentMethod,
} from "./bnpl-shared";

export type AffirmCustomerInfo = BnplCustomerInfo;

export type AffirmSubmitOptions = Omit<BnplSubmitOptions, "setupFutureUsage">;

export type AffirmCheckoutResponse = BnplCheckoutResponse;

const AffirmPaymentMethod = createBnplPaymentMethod({
  name: "affirm",
  endpointPath: "affirm",
  supportsSetupFutureUsage: false,
  popupClosedGraceMs: SHORT_POPUP_CLOSED_GRACE_MS,
});

export default AffirmPaymentMethod;
